import { render, staticRenderFns } from "./ArticleSearch.vue?vue&type=template&id=1f6d1820&scoped=true&"
import script from "./ArticleSearch.vue?vue&type=script&lang=js&"
export * from "./ArticleSearch.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSearch.vue?vue&type=style&index=0&id=1f6d1820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d1820",
  null
  
)

export default component.exports